module.exports = __webpack_public_path__ + "img/feature3-1x.0f4aacb.png";